export const STATION_NAMES = {
  // Основные станции
    "10202072": {
      "ru": "Берлин",
      "en": "Berlin",
      "cs": "Berlín",
      "pl": "Berlin",
      "uk": "Берлін"
    },
    "10202071": {
      "ru": "Дрезден",
      "en": "Dresden",
      "cs": "Drážďany",
      "pl": "Drezno",
      "uk": "Дрезден"
    },
    "10202104": {
      "ru": "Дюссельдорф",
      "en": "Düsseldorf",
      "cs": "Düsseldorf",
      "pl": "Düsseldorf",
      "uk": "Дюссельдорф"
    },
    "241620000": {
      "ru": "Кёльн/Бонн аэропорт",
      "en": "Cologne/Bonn Airport",
      "cs": "Letiště Kolín/Bonn",
      "pl": "Lotnisko Kolonia/Bonn",
      "uk": "Аеропорт Кельн/Бонн"
    },
    "10202006": {
      "ru": "Мюнхен",
      "en": "Munich",
      "cs": "Mnichov",
      "pl": "Monachium",
      "uk": "Мюнхен"
    },
    "10202021": {
      "ru": "Нюрнберг",
      "en": "Nuremberg",
      "cs": "Norimberk",
      "pl": "Norymberga",
      "uk": "Нюрнберг"
    },
    "10202023": {
      "ru": "Франкфурт-на-Майне",
      "en": "Frankfurt am Main",
      "cs": "Frankfurt nad Mohanem",
      "pl": "Frankfurt nad Menem",
      "uk": "Франкфурт-на-Майні"
    },
    "10202009": {
      "ru": "Штутгарт",
      "en": "Stuttgart",
      "cs": "Stuttgart",
      "pl": "Stuttgart",
      "uk": "Штутгарт"
    },
    "10202044": {
      "ru": "Брюссель",
      "en": "Brussels",
      "cs": "Brusel",
      "pl": "Bruksela",
      "uk": "Брюссель"
    },
    "10202020": {
      "ru": "Берн",
      "en": "Bern",
      "cs": "Bern",
      "pl": "Berno",
      "uk": "Берн"
    },
    "10202069": {
      "ru": "Женева",
      "en": "Geneva",
      "cs": "Ženeva",
      "pl": "Genewa",
      "uk": "Женева"
    },
    "10202068": {
      "ru": "Лозанна",
      "en": "Lausanne",
      "cs": "Lausanne",
      "pl": "Lozanna",
      "uk": "Лозанна"
    },
    "4552142001": {
      "ru": "Лугано",
      "en": "Lugano",
      "cs": "Lugano",
      "pl": "Lugano",
      "uk": "Луґано"
    },
    "4552142000": {
      "ru": "Люцерн",
      "en": "Lucerne",
      "cs": "Lucern",
      "pl": "Lucerna",
      "uk": "Люцерн"
    },
    "10202066": {
      "ru": "Санкт-Галлен",
      "en": "Sankt Gallen",
      "cs": "Sankt Gallen",
      "pl": "Sankt Gallen",
      "uk": "Sankt Gallen"
    },
    "10202067": {
      "ru": "Цюрих",
      "en": "Zurich",
      "cs": "Curych",
      "pl": "Zurych",
      "uk": "Цюріх"
    },
    "10202045": {
      "ru": "Люксембург",
      "en": "Luxemburg",
      "cs": "Luxemburg",
      "pl": "Luxemburg",
      "uk": "Luxemburg"
    },
    "3334999001": {
      "ru": "Биоград-на-Мору",
      "en": "Biograd na Moru",
      "cs": "Biograd na Moru",
      "pl": "Biograd na Moru",
      "uk": "Біоград-на-Мору"
    },
    "3334999003": {
      "ru": "Водице",
      "en": "Vodice",
      "cs": "Vodice",
      "pl": "Wodice",
      "uk": "Водіце"
    },
    "307730007": {
      "ru": "Задар",
      "en": "Zadar",
      "cs": "Zadar",
      "pl": "Zadar",
      "uk": "Zadar"
    },
    "3334999002": {
      "ru": "Пакоштане",
      "en": "Pakoštane",
      "cs": "Pakoštane",
      "pl": "Pakostane",
      "uk": "Пакоштане"
    },
    "271526009": {
      "ru": "Примоштен",
      "en": "Primošten",
      "cs": "Primošten",
      "pl": "Primosten",
      "uk": "Прімоштен"
    },
    "271526010": {
      "ru": "Сплит",
      "en": "Split",
      "cs": "Split",
      "pl": "Split",
      "uk": "Split"
    },
    "3334999000": {
      "ru": "Сукошан",
      "en": "Sukošan",
      "cs": "Sukošan",
      "pl": "Sukosan",
      "uk": "Сукошан"
    },
    "271526013": {
      "ru": "Трогир",
      "en": "Trogir",
      "cs": "Trogir",
      "pl": "Trogir",
      "uk": "Trogir"
    },
    "271526012": {
      "ru": "Шибеник",
      "en": "Šibenik",
      "cs": "Šibenik",
      "pl": "Szybenik",
      "uk": "Шибеник"
    },
    "10202084": {
      "ru": "Болонья",
      "en": "Bologna",
      "cs": "Bologna",
      "pl": "Bologna",
      "uk": "Bologna"
    },
    "10202080": {
      "ru": "Венеция",
      "en": "Venice",
      "cs": "Benátky",
      "pl": "Wenecja",
      "uk": "Венеція"
    },
    "2930911000": {
      "ru": "Комо",
      "en": "Como",
      "cs": "Como",
      "pl": "Como",
      "uk": "Комо"
    },
    "10202082": {
      "ru": "Милан",
      "en": "Milan",
      "cs": "Milán",
      "pl": "Mediolan",
      "uk": "Мілан"
    },
    "10202079": {
      "ru": "Падуя",
      "en": "Padua",
      "cs": "Padova",
      "pl": "Padwa",
      "uk": "Падуя"
    },
    "10202086": {
      "ru": "Рим",
      "en": "Rome",
      "cs": "Řím",
      "pl": "Rzym",
      "uk": "Рим"
    },
    "10202078": {
      "ru": "Удине",
      "en": "Udine",
      "cs": "Udine",
      "pl": "Udine",
      "uk": "Удіне"
    },
    "10202085": {
      "ru": "Флоренция",
      "en": "Florence",
      "cs": "Florencie",
      "pl": "Florencja",
      "uk": "Флоренція"
    },
    "7133810001": {
      "ru": "Батёво",
      "en": "Batyovo",
      "cs": "Baťovo",
      "pl": "Batyowo",
      "uk": "Батьово"
    },
    "6632040017": {
      "ru": "Бердичев",
      "en": "Berdychiv",
      "cs": "Berdyčiv",
      "pl": "Berdyczów",
      "uk": "Бердичів"
    },
    "6632040016": {
      "ru": "Белая Церковь",
      "en": "Bila Tserkva",
      "cs": "Bila Cerkva",
      "pl": "Biała Cerkiew",
      "uk": "Біла Церква"
    },
    "7133810010": {
      "ru": "Болехов",
      "en": "Bolekhiv",
      "cs": "Bolechiv",
      "pl": "Bolechów",
      "uk": "Болехів"
    },
    "6632040001": {
      "ru": "Харьков",
      "en": "Kharkiv",
      "cs": "Charkov",
      "pl": "Charków",
      "uk": "Харків"
    },
    "7133810016": {
      "ru": "Черновцы",
      "en": "Chernivtsi",
      "cs": "Černovice",
      "pl": "Czerniowce",
      "uk": "Чернівці"
    },
    "6133164002": {
      "ru": "Хмельницкий",
      "en": "Khmelnytskyi",
      "cs": "Chmelnyckyj",
      "pl": "Chmielnicki",
      "uk": "Хмельницький"
    },
    "7122881001": {
      "ru": "Чоп",
      "en": "Chop",
      "cs": "Čop",
      "pl": "Czop",
      "uk": "Чоп"
    },
    "6632040012": {
      "ru": "Днепр",
      "en": "Dnipro",
      "cs": "Dnipro",
      "pl": "Dniepr",
      "uk": "Дніпро"
    },
    "6633198001": {
      "ru": "Днепродзержинск",
      "en": "Dniprodzerzhynsk",
      "cs": "Dněprodzeržinsk",
      "pl": "Dnieprodzierżyńsk",
      "uk": "Дніпродзержинськ"
    },
    "7133810011": {
      "ru": "Долина",
      "en": "Dolyna",
      "cs": "Dolyna",
      "pl": "Dolina",
      "uk": "Долина"
    },
    "6632040005": {
      "ru": "Фастов",
      "en": "Fastiv",
      "cs": "Fastiv",
      "pl": "Fastów",
      "uk": "Фастів"
    },
    "6693502002": {
      "ru": "Hrebinka",
      "en": "Hrebinka",
      "cs": "Hrebinka",
      "pl": "Hrebinka",
      "uk": "Hrebinka"
    },
    "7133810014": {
      "ru": "Ивано-Франковск",
      "en": "Ivano-Frankivsk",
      "cs": "Ivano-Frankivsk",
      "pl": "Iwano-Frankiwsk",
      "uk": "Івано-Франківськ"
    },
    "7133810013": {
      "ru": "Калуш",
      "en": "Kalush",
      "cs": "Kaluš",
      "pl": "Kałusz",
      "uk": "Калуш"
    },
    "6632040007": {
      "ru": "Калиновка",
      "en": "Kalynivka",
      "cs": "Kalinivka",
      "pl": "Kalinówka",
      "uk": "Калинівка"
    },
    "6632040013": {
      "ru": "Каменское",
      "en": "Kamianske",
      "cs": "Kamjanske",
      "pl": "Kamieńskie",
      "uk": "Кам'янське"
    },
    "7133810002": {
      "ru": "Карпаты",
      "en": "Carpathians",
      "cs": "Karpaty",
      "pl": "Karpaty",
      "uk": "Карпати"
    },
    "7133810015": {
      "ru": "Коломыя",
      "en": "Kolomyia",
      "cs": "Kolomyja",
      "pl": "Kołomyja",
      "uk": "Коломия"
    },
    "6632040006": {
      "ru": "Казатин",
      "en": "Koziatyn",
      "cs": "Kozjatyn",
      "pl": "Koziatyn",
      "uk": "Козятин"
    },
    "6632040010": {
      "ru": "Красное",
      "en": "Krasne",
      "cs": "Krasne",
      "pl": "Krasne",
      "uk": "Красне"
    },
    "271526028": {
      "ru": "Киев",
      "en": "Kyiv",
      "cs": "Kyjev",
      "pl": "Kijów",
      "uk": "Київ"
    },
    "6632040004": {
      "ru": "Лубны",
      "en": "Lubny",
      "cs": "Lubny",
      "pl": "Łubny",
      "uk": "Лубни"
    },
    "271526030": {
      "ru": "Львов",
      "en": "Lviv",
      "cs": "Lvov",
      "pl": "Lwów",
      "uk": "Львів"
    },
    "6693502001": {
      "ru": "Люботин",
      "en": "Liubotyn",
      "cs": "Ljubotyn",
      "pl": "Lubotyń",
      "uk": "Люботин"
    },
    "7133810009": {
      "ru": "Моршин",
      "en": "Morshyn",
      "cs": "Moršyn",
      "pl": "Morszyn",
      "uk": "Моршин"
    },
    "6632040003": {
      "ru": "Миргород",
      "en": "Myrhorod",
      "cs": "Myrhorod",
      "pl": "Mirgorod",
      "uk": "Миргород"
    },
    "6693502003": {
      "ru": "Александрия",
      "en": "Oleksandriia",
      "cs": "Oleksandrija",
      "pl": "Aleksandria",
      "uk": "Олександрія"
    },
    "6632040002": {
      "ru": "Полтава",
      "en": "Poltava",
      "cs": "Poltava",
      "pl": "Połtawa",
      "uk": "Полтава"
    },
    "7133810012": {
      "ru": "Рожнятов",
      "en": "Rozhniativ",
      "cs": "Rožňatov",
      "pl": "Rożniatów",
      "uk": "Рожнятів"
    },
    "7133810006": {
      "ru": "Сколе",
      "en": "Skole",
      "cs": "Skole",
      "pl": "Skole",
      "uk": "Сколе"
    },
    "7133810005": {
      "ru": "Славское",
      "en": "Slavske",
      "cs": "Slavské",
      "pl": "Sławskie",
      "uk": "Славське"
    },
    "6632040015": {
      "ru": "Смела",
      "en": "Smila",
      "cs": "Směla",
      "pl": "Smiła",
      "uk": "Сміла"
    },
    "7133810008": {
      "ru": "Стрый",
      "en": "Stryi",
      "cs": "Stryj",
      "pl": "Stryj",
      "uk": "Стрий"
    },
    "7133810003": {
      "ru": "Свалява",
      "en": "Svalyava",
      "cs": "Svaljava",
      "pl": "Swalawy",
      "uk": "Свалява"
    },
    "271526038": {
      "ru": "Тернополь",
      "en": "Ternopil",
      "cs": "Ternopil",
      "pl": "Tarnopol",
      "uk": "Тернопіль"
    },
    "6133164003": {
      "ru": "Винница",
      "en": "Vinnytsia",
      "cs": "Vinnytsja",
      "pl": "Winnica",
      "uk": "Вінниця"
    },
    "6632040009": {
      "ru": "Волочиск",
      "en": "Volochysk",
      "cs": "Voločisk",
      "pl": "Wołoczyska",
      "uk": "Волочиськ"
    },
    "7133810004": {
      "ru": "Воловец",
      "en": "Volovets",
      "cs": "Volovec",
      "pl": "Wołowiec",
      "uk": "Воловець"
    },
    "6632040014": {
      "ru": "Знаменка",
      "en": "Znamianka",
      "cs": "Znamjanka",
      "pl": "Znamianka",
      "uk": "Знам'янка"
    },
    "6632040011": {
      "ru": "Запорожье",
      "en": "Zaporizhzhia",
      "cs": "Záporoží",
      "pl": "Zaporoże",
      "uk": "Запоріжжя"
    },
    "4016707000": {
      "ru": "Мукачево",
      "en": "Mukachevo",
      "cs": "Mukačevo",
      "pl": "Mukaczewo",
      "uk": "Мукачево"
    },
    "4016707001": {
      "ru": "Ужгород",
      "en": "Uzhhorod",
      "cs": "Užhorod",
      "pl": "Użhorod",
      "uk": "Ужгород"
    },
    "2651667000": {
      "ru": "Лион",
      "en": "Lyon",
      "cs": "Lyon",
      "pl": "Lyon",
      "uk": "Ліон"
    },
    "10202096": {
      "ru": "Париж",
      "en": "Paris",
      "cs": "Paříž",
      "pl": "Paryż",
      "uk": "Париж"
    },
    "1805420001": {
      "ru": "Страсбург",
      "en": "Strasbourg",
      "cs": "Štrasburk",
      "pl": "Strasburg",
      "uk": "Страсбург"
    },
    "10202089": {
      "ru": "Дьёр",
      "en": "Győr",
      "cs": "Ráb",
      "pl": "Győr",
      "uk": "Дьєр"
    },
    "3798068000": {
      "ru": "Хедьешхалом",
      "en": "Hegyeshalom",
      "cs": "Hegyeshalom",
      "pl": "Hegyeshalom",
      "uk": "Гедьєшгалом"
    },
    "10202088": {
      "ru": "Мошонмадьяровар",
      "en": "Mosonmagyaróvár",
      "cs": "Mosonmagyaróvár",
      "pl": "Mosonmagyaróvár",
      "uk": "Мошонмадьяровар"
    },
    "10202091": {
      "ru": "Будапешт",
      "en": "Budapest",
      "cs": "Budapešť",
      "pl": "Budapeszt",
      "uk": "Будапешт"
    },
    "888040004": {
      "ru": "Инсбрук",
      "en": "Innsbruck",
      "cs": "Innsbruck",
      "pl": "Innsbruck",
      "uk": "Інсбрук"
    },
    "4111558001": {
      "ru": "Амштеттен",
      "en": "Amstetten",
      "cs": "Amstetten",
      "pl": "Amstetten",
      "uk": "Амштеттен"
    },
    "4111558003": {
      "ru": "Атнанг-Пуххайм",
      "en": "Attnang-Puchheim",
      "cs": "Attnang-Puchheim",
      "pl": "Attnang-Puchheim",
      "uk": "Атнанг-Пуххайм"
    },
    "4111558002": {
      "ru": "Вельс",
      "en": "Wels",
      "cs": "Wels",
      "pl": "Wels",
      "uk": "Вельс"
    },
    "10202052": {
      "ru": "Вена",
      "en": "Vienna",
      "cs": "Vídeň",
      "pl": "Wiedeń",
      "uk": "Відень"
    },
    "888040003": {
      "ru": "Зальцбург",
      "en": "Salzburg",
      "cs": "Salcburk",
      "pl": "Salzburg",
      "uk": "Зальцбург"
    },
    "888040001": {
      "ru": "Линц",
      "en": "Linz",
      "cs": "Linec",
      "pl": "Linz",
      "uk": "Лінц"
    },
    "4111558000": {
      "ru": "Санкт-Пёльтен",
      "en": "Sankt Pölten",
      "cs": "Sankt Pölten",
      "pl": "Sankt Pölten",
      "uk": "Санкт-Пельтен"
    },
    "6527887004": {
      "ru": "Целе",
      "en": "Celje",
      "cs": "Celje",
      "pl": "Celje",
      "uk": "Целє"
    },
    "10202049": {
      "ru": "Лондон",
      "en": "London",
      "cs": "Londýn",
      "pl": "Londyn",
      "uk": "Лондон"
    },
    "2147875000": {
      "ru": "Богумин",
      "en": "Bohumín",
      "cs": "Bohumín",
      "pl": "Bogumin",
      "uk": "Богумін"
    },
    "5845172001": {
      "ru": "Гавличкув-Брод",
      "en": "Havlíčkův Brod",
      "cs": "Havlíčkův Brod",
      "pl": "Havlíčkův Brod",
      "uk": "Гавлічкув-Брод"
    },
    "2370326000": {
      "ru": "Гулин",
      "en": "Hulín",
      "cs": "Hulín",
      "pl": "Hulin",
      "uk": "Гулін"
    },
    "5095523072": {
      "ru": "Йистебник",
      "en": "Jistebník",
      "cs": "Jistebník",
      "pl": "Jistebnik",
      "uk": "Їстебнік"
    },
    "4961571001": {
      "ru": "Коетин",
      "en": "Kojetín",
      "cs": "Kojetín",
      "pl": "Kojetin",
      "uk": "Коєтін"
    },
    "7070607001": {
      "ru": "Липник-над-Бечвой",
      "en": "Lipník nad Bečvou",
      "cs": "Lipník nad Bečvou",
      "pl": "Lipnik nad Beczwą",
      "uk": "Ліпнік-над-Бечвою"
    },
    "5010254221": {
      "ru": "Литомержице",
      "en": "Litoměřice",
      "cs": "Litoměřice",
      "pl": "Litomierzyce",
      "uk": "Літомержіце"
    },
    "5812839004": {
      "ru": "Лиса-над-Лабем",
      "en": "Lysá nad Labem",
      "cs": "Lysá nad Labem",
      "pl": "Łysa nad Łabą",
      "uk": "Лиса-над-Лабем"
    },
    "5010254426": {
      "ru": "Мельник",
      "en": "Mělník",
      "cs": "Mělník",
      "pl": "Mielnik",
      "uk": "Мельнік"
    },
    "5009205000": {
      "ru": "Незамыслице",
      "en": "Nezamyslice",
      "cs": "Nezamyslice",
      "pl": "Nezamyslice",
      "uk": "Незамисліце"
    },
    "5812839003": {
      "ru": "Нимбурк",
      "en": "Nymburk",
      "cs": "Nymburk",
      "pl": "Nymburk",
      "uk": "Німбурк"
    },
    "5812839002": {
      "ru": "Подебрады",
      "en": "Poděbrady",
      "cs": "Poděbrady",
      "pl": "Podiebrad",
      "uk": "Подєбради"
    },
    "2370326001": {
      "ru": "Пршеров",
      "en": "Přerov",
      "cs": "Přerov",
      "pl": "Przerów",
      "uk": "Пршеров"
    },
    "5812839005": {
      "ru": "Стара-Болеслав",
      "en": "Stará Boleslav",
      "cs": "Stará Boleslav",
      "pl": "Stara Bolesław",
      "uk": "Стара-Болеслав"
    },
    "4961571003": {
      "ru": "Студенка",
      "en": "Studénka",
      "cs": "Studénka",
      "pl": "Studenka",
      "uk": "Студенка"
    },
    "5095523141": {
      "ru": "Сухдол-над-Одрой",
      "en": "Suchdol nad Odrou",
      "cs": "Suchdol nad Odrou",
      "pl": "Suchdol nad Odrą",
      "uk": "Сухдол-над-Одрою"
    },
    "5812839001": {
      "ru": "Велки-Осек",
      "en": "Velký Osek",
      "cs": "Velký Osek",
      "pl": "Wielki Osek",
      "uk": "Великий Осек"
    },
    "4961571000": {
      "ru": "Вышков-на-Мораве",
      "en": "Vyškov na Moravě",
      "cs": "Vyškov na Moravě",
      "pl": "Wyszków na Morawach",
      "uk": "Вишків-на-Мораві"
    },
    "5812839006": {
      "ru": "Вшетаты",
      "en": "Všetaty",
      "cs": "Všetaty",
      "pl": "Wszetaty",
      "uk": "Вшетати"
    },
    "10202105": {
      "ru": "Усти-над-Лабем",
      "en": "Ústí nad Labem",
      "cs": "Ústí nad Labem",
      "pl": "Uście nad Łabą",
      "uk": "Усті-над-Лабем"
    },
    "5010254372": {
      "ru": "Штети",
      "en": "Štětí",
      "cs": "Štětí",
      "pl": "Szteti",
      "uk": "Штеті"
    },
    "5845172002": {
      "ru": "Ждяр-над-Сазавой",
      "en": "Žďár nad Sázavou",
      "cs": "Žďár nad Sázavou",
      "pl": "Żdziar nad Sazawą",
      "uk": "Ждяр-над-Сазавою"
    },
    "3741270003": {
      "ru": "Бланско",
      "en": "Blansko",
      "cs": "Blansko",
      "pl": "Blansko",
      "uk": "Бланско"
    },
    "165611000": {
      "ru": "Бржецлав",
      "en": "Břeclav",
      "cs": "Břeclav",
      "pl": "Brzecław",
      "uk": "Бржецлав"
    },
    "10202002": {
      "ru": "Брно",
      "en": "Brno",
      "cs": "Brno",
      "pl": "Brno",
      "uk": "Брно"
    },
    "1313136001": {
      "ru": "Быстрице-у-Тршинца",
      "en": "Bystřice nad Olší",
      "cs": "Bystřice nad Olší",
      "pl": "Bystrzyca nad Olzą",
      "uk": "Бистриця-над-Ольші"
    },
    "2624922004": {
      "ru": "Врановска-Вес",
      "en": "Vranovská Ves",
      "cs": "Vranovská Ves",
      "pl": "Wranowska Wieś",
      "uk": "Врановска-Вес"
    },
    "372842004": {
      "ru": "Гавиржов",
      "en": "Havířov",
      "cs": "Havířov",
      "pl": "Hawierzów",
      "uk": "Гавіржов"
    },
    "372842003": {
      "ru": "Границе-на-Мораве",
      "en": "Hranice na Moravě",
      "cs": "Hranice na Moravě",
      "pl": "Granice na Morawach",
      "uk": "Граніце-на-Мораві"
    },
    "2624922001": {
      "ru": "Желетава",
      "en": "Желетава",
      "cs": "Желетава",
      "pl": "Желетава",
      "uk": "Желетава"
    },
    "372842002": {
      "ru": "Забржех-на-Мораве",
      "en": "Забржех-на-Мораве",
      "cs": "Забржех-на-Мораве",
      "pl": "Забржех-на-Мораве",
      "uk": "Забржех-на-Мораве"
    },
    "17653000": {
      "ru": "Злин",
      "en": "Злин",
      "cs": "Злин",
      "pl": "Злин",
      "uk": "Злин"
    },
    "1742368001": {
      "ru": "Зноймо",
      "en": "Znaim",
      "cs": "Znaim",
      "pl": "Znaim",
      "uk": "Znaim"
    },
    "17554000": {
      "ru": "Йиглава",
      "en": "Iglau",
      "cs": "Iglau",
      "pl": "Iglau",
      "uk": "Iglau"
    },
    "1303398000": {
      "ru": "Йирков",
      "en": "Jirkov",
      "cs": "Jirkov",
      "pl": "Jirkov",
      "uk": "Jirkov"
    },
    "17904010": {
      "ru": "Карловы Вары",
      "en": "Karlsbad",
      "cs": "Karlsbad",
      "pl": "Karlsbad",
      "uk": "Karlsbad"
    },
    "3088840000": {
      "ru": "Колин",
      "en": "Kolonia",
      "cs": "Kolonia",
      "pl": "Kolonia",
      "uk": "Kolonia"
    },
    "17904000": {
      "ru": "Кромержиж",
      "en": "Кромержиж",
      "cs": "Кромержиж",
      "pl": "Кромержиж",
      "uk": "Кромержиж"
    },
    "3741270002": {
      "ru": "Летовице",
      "en": "Letovice",
      "cs": "Letovice",
      "pl": "Letovice",
      "uk": "Letovice"
    },
    "17904003": {
      "ru": "Либерец",
      "en": "Reichenberg",
      "cs": "Reichenberg",
      "pl": "Reichenberg",
      "uk": "Reichenberg"
    },
    "1084369001": {
      "ru": "Лоуны",
      "en": "Louny",
      "cs": "Louny",
      "pl": "Louny",
      "uk": "Louny"
    },
    "2624922002": {
      "ru": "Моравске Будейовице",
      "en": "Моравске Будейовице",
      "cs": "Моравске Будейовице",
      "pl": "Моравске Будейовице",
      "uk": "Моравске Будейовице"
    },
    "1084369000": {
      "ru": "Мост",
      "en": "Most",
      "cs": "Most",
      "pl": "Most",
      "uk": "Most"
    },
    "1558067000": {
      "ru": "Навси (Яблунков)",
      "en": "Навси (Яблунков)",
      "cs": "Навси (Яблунков)",
      "pl": "Навси (Яблунков)",
      "uk": "Навси (Яблунков)"
    },
    "10202032": {
      "ru": "Новый Йичин",
      "en": "Nowy Jiczyn",
      "cs": "Nowy Jiczyn",
      "pl": "Nowy Jiczyn",
      "uk": "Nowy Jiczyn"
    },
    "10202031": {
      "ru": "Оломоуц",
      "en": "Olomouc",
      "cs": "Olomouc",
      "pl": "Olomouc",
      "uk": "Olomouc"
    },
    "3741270000": {
      "ru": "Опава восток",
      "en": "Opawa Wschodnia",
      "cs": "Opawa Wschodnia",
      "pl": "Opawa Wschodnia",
      "uk": "Opawa Wschodnia"
    },
    "10202000": {
      "ru": "Острава",
      "en": "Ostrawa",
      "cs": "Ostrawa",
      "pl": "Ostrawa",
      "uk": "Ostrawa"
    },
    "2624922003": {
      "ru": "Павлице",
      "en": "Pavlice",
      "cs": "Pavlice",
      "pl": "Pavlice",
      "uk": "Pavlice"
    },
    "372842000": {
      "ru": "Пардубице",
      "en": "Pardubice",
      "cs": "Pardubice",
      "pl": "Pardubice",
      "uk": "Pardubice"
    },
    "17904007": {
      "ru": "Писек",
      "en": "Писек",
      "cs": "Писек",
      "pl": "Писек",
      "uk": "Писек"
    },
    "10202004": {
      "ru": "Пльзень",
      "en": "Pilsen",
      "cs": "Pilsen",
      "pl": "Pilsen",
      "uk": "Pilsen"
    },
    "10202003": {
      "ru": "Прага",
      "en": "Praha",
      "cs": "Praha",
      "pl": "Praha",
      "uk": "Praha"
    },
    "423394000": {
      "ru": "Пршибор",
      "en": "Пршибор",
      "cs": "Пршибор",
      "pl": "Пршибор",
      "uk": "Пршибор"
    },
    "3741270001": {
      "ru": "Свитавы",
      "en": "Svitavy",
      "cs": "Svitavy",
      "pl": "Svitavy",
      "uk": "Svitavy"
    },
    "4406925000": {
      "ru": "Скалице-над-Свитавой",
      "en": "Skalice nad Svitavou",
      "cs": "Skalice nad Svitavou",
      "pl": "Skalice nad Svitavou",
      "uk": "Skalice nad Svitavou"
    },
    "721174000": {
      "ru": "Соколов",
      "en": "Sokolov",
      "cs": "Sokolov",
      "pl": "Sokolov",
      "uk": "Sokolov"
    },
    "508808001": {
      "ru": "Тршинец центр",
      "en": "Trzyniec Centrum",
      "cs": "Trzyniec Centrum",
      "pl": "Trzyniec Centrum",
      "uk": "Trzyniec Centrum"
    },
    "10202064": {
      "ru": "Фридек-Мистек",
      "en": "Фридек-Мистек",
      "cs": "Фридек-Мистек",
      "pl": "Фридек-Мистек",
      "uk": "Фридек-Мистек"
    },
    "721174001": {
      "ru": "Хеб",
      "en": "Cheb",
      "cs": "Cheb",
      "pl": "Cheb",
      "uk": "Cheb"
    },
    "1084369003": {
      "ru": "Хомутов",
      "en": "Chomutov",
      "cs": "Chomutov",
      "pl": "Chomutov",
      "uk": "Chomutov"
    },
    "1313136000": {
      "ru": "Чешская Тршебова",
      "en": "Чешская Тршебова",
      "cs": "Чешская Тршебова",
      "pl": "Чешская Тршебова",
      "uk": "Чешская Тршебова"
    },
    "17904008": {
      "ru": "Чешские Будейовице",
      "en": "Чешские Будейовице",
      "cs": "Чешские Будейовице",
      "pl": "Чешские Будейовице",
      "uk": "Чешские Будейовице"
    },
    "17904009": {
      "ru": "Чешский Крумлов",
      "en": "Чешский Крумлов",
      "cs": "Чешский Крумлов",
      "pl": "Чешский Крумлов",
      "uk": "Чешский Крумлов"
    },
    "508808000": {
      "ru": "Чешский Тешин",
      "en": "Czeski Cieszyn",
      "cs": "Czeski Cieszyn",
      "pl": "Czeski Cieszyn",
      "uk": "Czeski Cieszyn"
    },
    "5118475002": {
      "ru": "Nové Mesto nad Váhom",
      "en": "Nové Mesto nad Váhom",
      "cs": "Nové Mesto nad Váhom",
      "pl": "Nové Mesto nad Váhom",
      "uk": "Nové Mesto nad Váhom"
    },
    "5118475001": {
      "ru": "Piešťany",
      "en": "Piešťany",
      "cs": "Piešťany",
      "pl": "Piešťany",
      "uk": "Piešťany"
    },
    "5118475004": {
      "ru": "Púchov",
      "en": "Púchov",
      "cs": "Púchov",
      "pl": "Púchov",
      "uk": "Púchov"
    },
    "5118475003": {
      "ru": "Trenčianska Teplá",
      "en": "Trenčianska Teplá",
      "cs": "Trenčianska Teplá",
      "pl": "Trenčianska Teplá",
      "uk": "Trenčianska Teplá"
    },
    "1723745000": {
      "ru": "Trnava",
      "en": "Trnava",
      "cs": "Trnava",
      "pl": "Trnava",
      "uk": "Trnava"
    },
    "2370326004": {
      "ru": "Turčianske Teplice",
      "en": "Turčianske Teplice",
      "cs": "Turčianske Teplice",
      "pl": "Turčianske Teplice",
      "uk": "Turčianske Teplice"
    },
    "3741270006": {
      "ru": "Бановце-над-Ондавоу",
      "en": "Бановце-над-Ондавоу",
      "cs": "Бановце-над-Ондавоу",
      "pl": "Бановце-над-Ондавоу",
      "uk": "Бановце-над-Ондавоу"
    },
    "10202062": {
      "ru": "Банска Быстрица",
      "en": "Банска Быстрица",
      "cs": "Банска Быстрица",
      "pl": "Банска Быстрица",
      "uk": "Банска Быстрица"
    },
    "14780002": {
      "ru": "Бардейов",
      "en": "Bardejov",
      "cs": "Bardejov",
      "pl": "Bardejov",
      "uk": "Bardejov"
    },
    "10202001": {
      "ru": "Братислава",
      "en": "Blava",
      "cs": "Blava",
      "pl": "Blava",
      "uk": "Blava"
    },
    "3001552001": {
      "ru": "Вранов-над-Топлёу",
      "en": "Вранов-над-Топлёу",
      "cs": "Вранов-над-Топлёу",
      "pl": "Вранов-над-Топлёу",
      "uk": "Вранов-над-Топлёу"
    },
    "49584000": {
      "ru": "Врутки",
      "en": "Ruttka",
      "cs": "Ruttka",
      "pl": "Ruttka",
      "uk": "Ruttka"
    },
    "3001552002": {
      "ru": "Гиралтовице",
      "en": "Giraltovce",
      "cs": "Giraltovce",
      "pl": "Giraltovce",
      "uk": "Giraltovce"
    },
    "10202038": {
      "ru": "Жилина",
      "en": "Zsolna",
      "cs": "Zsolna",
      "pl": "Zsolna",
      "uk": "Zsolna"
    },
    "10202099": {
      "ru": "Зволен",
      "en": "Zvolen",
      "cs": "Zvolen",
      "pl": "Zvolen",
      "uk": "Zvolen"
    },
    "14780000": {
      "ru": "Кежмарок",
      "en": "Кежмарок",
      "cs": "Кежмарок",
      "pl": "Кежмарок",
      "uk": "Кежмарок"
    },
    "1762994001": {
      "ru": "Кисак (у города Прешов)",
      "en": "Kysak (pod Preszowem)",
      "cs": "Kysak (pod Preszowem)",
      "pl": "Kysak (pod Preszowem)",
      "uk": "Kysak (pod Preszowem)"
    },
    "10202033": {
      "ru": "Кошице",
      "en": "Kassa",
      "cs": "Kassa",
      "pl": "Kassa",
      "uk": "Kassa"
    },
    "10202036": {
      "ru": "Липтовский Микулаш",
      "en": "Липтовский Микулаш",
      "cs": "Липтовский Микулаш",
      "pl": "Липтовский Микулаш",
      "uk": "Липтовский Микулаш"
    },
    "2317706000": {
      "ru": "Маргецаны",
      "en": "Margitfalva",
      "cs": "Margitfalva",
      "pl": "Margitfalva",
      "uk": "Margitfalva"
    },
    "49584001": {
      "ru": "Мартин",
      "en": "Martin",
      "cs": "Martin",
      "pl": "Martin",
      "uk": "Martin"
    },
    "10202039": {
      "ru": "Поважска Быстрица",
      "en": "Поважска Быстрица",
      "cs": "Поважска Быстрица",
      "pl": "Поважска Быстрица",
      "uk": "Поважска Быстрица"
    },
    "49584004": {
      "ru": "Подолинец",
      "en": "Podolin",
      "cs": "Podolin",
      "pl": "Podolin",
      "uk": "Podolin"
    },
    "10202035": {
      "ru": "Попрад",
      "en": "Poprad",
      "cs": "Poprad",
      "pl": "Poprad",
      "uk": "Poprad"
    },
    "10202034": {
      "ru": "Прешов",
      "en": "Eperjes",
      "cs": "Eperjes",
      "pl": "Eperjes",
      "uk": "Eperjes"
    },
    "3001552000": {
      "ru": "Раславице",
      "en": "Raszlavica",
      "cs": "Raszlavica",
      "pl": "Raszlavica",
      "uk": "Raszlavica"
    },
    "10202037": {
      "ru": "Ружомберок",
      "en": "Ружомберок",
      "cs": "Ружомберок",
      "pl": "Ружомберок",
      "uk": "Ружомберок"
    },
    "3001552003": {
      "ru": "Свидник",
      "en": "Свидник",
      "cs": "Свидник",
      "pl": "Свидник",
      "uk": "Свидник"
    },
    "49819006": {
      "ru": "Сечовце",
      "en": "Sečovce",
      "cs": "Sečovce",
      "pl": "Sečovce",
      "uk": "Сечовце"
    },
    "14780005": {
      "ru": "Снина",
      "en": "Snina",
      "cs": "Snina",
      "pl": "Snina",
      "uk": "Snina"
    },
    "49584003": {
      "ru": "Спишска Бела",
      "en": "Спишска Бела",
      "cs": "Спишска Бела",
      "pl": "Спишска Бела",
      "uk": "Спишска Бела"
    },
    "1762994000": {
      "ru": "Спишска Нова Вес",
      "en": "Спишска Нова Вес",
      "cs": "Спишска Нова Вес",
      "pl": "Спишска Нова Вес",
      "uk": "Спишска Нова Вес"
    },
    "14780001": {
      "ru": "Стара Любовня",
      "en": "Стара Любовня",
      "cs": "Стара Любовня",
      "pl": "Стара Любовня",
      "uk": "Стара Любовня"
    },
    "3741270007": {
      "ru": "Стражске",
      "en": "Стражске",
      "cs": "Стражске",
      "pl": "Стражске",
      "uk": "Стражске"
    },
    "3001552004": {
      "ru": "Стропков",
      "en": "Stropkov",
      "cs": "Stropkov",
      "pl": "Stropkov",
      "uk": "Stropkov"
    },
    "10202040": {
      "ru": "Тренчин",
      "en": "Trenczyn",
      "cs": "Trenczyn",
      "pl": "Trenczyn",
      "uk": "Trenczyn"
    },
    "14780004": {
      "ru": "Хуменне",
      "en": "Homonna",
      "cs": "Homonna",
      "pl": "Homonna",
      "uk": "Homonna"
    },
    "508808002": {
      "ru": "Чадца",
      "en": "Csaca",
      "cs": "Csaca",
      "pl": "Csaca",
      "uk": "Csaca"
    },
    "49584002": {
      "ru": "Штрба",
      "en": "Csorba",
      "cs": "Csorba",
      "pl": "Csorba",
      "uk": "Csorba"
    },
    "7537091001": {
      "ru": "Czechowice-Dziedzice",
      "en": "Czechowice-Dziedzice",
      "cs": "Czechowice-Dziedzice",
      "pl": "Czechowice-Dziedzice",
      "uk": "Czechowice-Dziedzice"
    },
    "1225791001": {
      "ru": "Katowice",
      "en": "Katowicy",
      "cs": "Katowicy",
      "pl": "Katowicy",
      "uk": "Katowicy"
    },
    "1606573002": {
      "ru": "Katowice Airport",
      "en": "Katowice Flughafen",
      "cs": "Katowice Flughafen",
      "pl": "Katowice Flughafen",
      "uk": "Katowice Flughafen"
    },
    "5990055004": {
      "ru": "Přemyšl",
      "en": "Přemyšl",
      "cs": "Přemyšl",
      "pl": "Přemyšl",
      "uk": "Přemyšl"
    },
    "1606573000": {
      "ru": "Rybnik",
      "en": "Rybnik",
      "cs": "Rybnik",
      "pl": "Rybnik",
      "uk": "Rybnik"
    },
    "6256272001": {
      "ru": "Tarnov",
      "en": "Tarnov",
      "cs": "Tarnov",
      "pl": "Tarnov",
      "uk": "Tarnov"
    },
    "2737640000": {
      "ru": "Warszawa",
      "en": "Warsaw",
      "cs": "Warsaw",
      "pl": "Warsaw",
      "uk": "Warsaw"
    },
    "1801253000": {
      "ru": "Wroclaw",
      "en": "Wroclaw",
      "cs": "Wroclaw",
      "pl": "Wroclaw",
      "uk": "Wroclaw"
    },
    "5990055007": {
      "ru": "Řešov",
      "en": "Řešov",
      "cs": "Řešov",
      "pl": "Řešov",
      "uk": "Řešov"
    },
    "1225791000": {
      "ru": "Краков",
      "en": "Cracow",
      "cs": "Cracow",
      "pl": "Cracow",
      "uk": "Cracow"
    },
    "4971491000": {
      "ru": "Den Haag",
      "en": "The Hague",
      "cs": "The Hague",
      "pl": "The Hague",
      "uk": "The Hague"
    },
    "10202030": {
      "ru": "Амстердам",
      "en": "Amstr",
      "cs": "Amstr",
      "pl": "Amstr",
      "uk": "Amstr"
    },
    "10202028": {
      "ru": "Роттердам",
      "en": "Rotterdam",
      "cs": "Rotterdam",
      "pl": "Rotterdam",
      "uk": "Rotterdam"
    },
    "10202026": {
      "ru": "Эйндховен",
      "en": "Eindhoven",
      "cs": "Eindhoven",
      "pl": "Eindhoven",
      "uk": "Eindhoven"
    }
  
};

// Добавляем сообщения об ошибке для всех языков
const STATION_NOT_FOUND = {
  ru: 'Станция не найдена',
  en: 'Station not found',
  cs: 'Stanice nenalezena',
  pl: 'Stacja nie znaleziona',
  uk: 'Станцію не знайдено'
};

// Функция для получения названия станции с учетом языка
export const getStationName = (stationId, locale = 'ru') => {
  if (!stationId) return '';
  
  console.log('Getting station name for:', {
    stationId,
    locale,
    hasStation: !!STATION_NAMES[stationId],
    availableStations: Object.keys(STATION_NAMES).length
  });
  
  const station = STATION_NAMES[stationId];
  if (!station) {
    console.warn(`Translation not found for station ID: ${stationId}. Please add it to the stations list.`);
    return STATION_NOT_FOUND[locale] || STATION_NOT_FOUND.en;
  }
  
  return station[locale] || station.en || stationId;
};

// Функция для получения отсортированного списка всех станций
export const getAllStations = (lang = 'ru') => {
  return Object.entries(STATION_NAMES)
    .map(([id, names]) => ({
      id,
      name: names[lang] || names.en
    }))
    .sort((a, b) => 
      a.name.localeCompare(b.name, lang, {
        sensitivity: 'base',
        ignorePunctuation: true
      })
    );
};

// Функция для поиска станции по части названия
export const findStationsByName = (searchText, lang = 'ru') => {
  const searchLower = searchText.toLowerCase();
  return Object.entries(STATION_NAMES)
    .filter(([_, names]) => 
      names[lang]?.toLowerCase().includes(searchLower) || 
      names.en?.toLowerCase().includes(searchLower)
    )
    .map(([id, names]) => ({
      id,
      name: names[lang] || names.en
    }));
};

// Функция для получения локализованного названия станции из маршрута
export const getLocalizedStationName = (stationId, route, locale = 'ru') => {
  if (!stationId) return '';
  
  // Пытаемся получить название из route.stations сначала
  if (route?.stations?.[stationId]) {
    const station = route.stations[stationId];
    // Возвращаем название из route.stations без попытки использовать getStationName
    return station.fullName || station.name || '';
  }
  
  // Если нет в route.stations, используем утилиту getStationName
  return getStationName(stationId, locale);
}; 